<template>
    <router-link :to="{ name: 'detailService', params: { categorieId: elId, categorieName: catTitle}}" class="rounded p-4" href="">
        <div class="service-item">
          <div class="service-inner">
              <div class="service-img">
                  <img :src="catImage" class="img-fluid w-100 rounded" alt="Image" style="height: 225px !important; object-fit: cover;">
              </div>
             <div class="service-title">
                  <div class="service-title-name">
                      <div class="text-center rounded p-3 mx-5 mb-4" style="background: #F7A51B !important;">
                          <a href="#" class="text-white mb-0">{{ catTitle }}</a>
                      </div>
                      <a class="btn bg-light text-secondary rounded-pill py-1 px-5 mb-2" href="#">Détails</a>
                  </div>
                  <div class="service-content pb-4">
                      <a href="#"><h6 class="text-white py-1 mb-2 m-3">{{ catTitle }}</h6></a>
                      <div class="px-4">
                          <p class="mb-4">{{ catDescription }}</p><br>
                          <a class="btn btn-primary border-secondary rounded-pill py-1 px-5" href="#" style="background-color: #ffffff !important; color: #F7A51B !important;">
                            Détails
                        </a>
                      </div>
                  </div>
              </div>
          </div>
        </div>
    </router-link>


</template>

<script>

export default {
  name: 'CategoryCard',
 props: {
    catTitle: { type: String, required: true },
    catOfferNbr: { type: Number, required: true },
    catImage: { type: String, required: false },
    elId: { type: Number, required: true },
    catDescription: { type: String, required: true },
  }
}
</script>

